import {Component, Input, OnInit, ViewChild} from '@angular/core';

import {filterData} from '../../data';
import {ActivatedRoute, Router} from '@angular/router';
import {IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts} from 'ngx-bootstrap-multiselect';
import {ApiService} from '../../../../../shared/services/api.service';

@Component({
    selector: 'indiapicture-sidebar-one',
    templateUrl: './sidebar-one.component.html',
    styleUrls: ['./sidebar-one.component.scss']
})

export class SidebarOneComponent implements OnInit {
    indianSelect: number[];
    indianCollections: IMultiSelectOption[];
    internationalSelect: number[];
    internationalCollections: IMultiSelectOption[];
    videoSelect: number[];
    videoCollections: IMultiSelectOption[];

    @Input() toggle = false;
    @Input() searchText = '';
    filterData = filterData;
    // collectionData = masterData;
    collectionData: any = [];
    params = {};
    durationRange: any = [0, 120];
    @ViewChild('durationSlider') durationSlider: any;

    fpsRange: any = [0, 60];
    @ViewChild('fpsSlider') fpsSlider: any;

    category = 'creative';
    type = 'images';

    constructor(public activeRoute: ActivatedRoute, public router: Router, public apiService: ApiService) {
        activeRoute.params.subscribe(params => {
            this.type = params['type'];
        });

        activeRoute.queryParams.subscribe(params => {
            this.params = params;
            this.category = this.params['category'];

            if (params['durationFrom'] && params['durationTo']) {
                this.durationRange = [
                    params['durationFrom'],
                    params['durationTo']
                ];
            } else {
                this.durationRange = [0, 120];

                if (this.durationSlider) {
                    this.durationSlider.slider.reset({min: 0, max: 100});
                }
            }

            if (params['fpsFrom'] && params['fpsTo']) {
                this.fpsRange = [
                    params['fpsFrom'],
                    params['fpsTo']
                ];
            } else {
                this.fpsRange = [0, 60];

                if (this.fpsSlider) {
                    this.fpsSlider.slider.reset({min: 0, max: 100});
                }
            }


        });
    }

    ngOnInit(): void {
        // 🟢 Safely get current user
        const currentUserData = localStorage.getItem('currentUser');
        const currentUser = currentUserData ? JSON.parse(currentUserData) : null;

        // 🟢 Default to IP if user not logged in or license_type missing
        let allowedPlatform = 'IP';

        if (currentUser && currentUser.license_type) {
            const licenseType = currentUser.license_type;

            if (licenseType === 'standard_yearly' || licenseType === 'standard_monthly') {
            allowedPlatform = 'IPB';
            } else if (licenseType === 'standard_subscription' || licenseType === 'enhanced') {
            allowedPlatform = 'IP';
            }
        }

        // 🟢 Fetch collections and filter based on platform
        this.apiService.getCollectionsIPAndIPB().subscribe(result => {
            let allCollections = result?.data || [];

            // TEMPORARY: hide these collections by name. Revert after temporhiddenCollectionNamesary period.
            const hiddenCollectionNames = [
                'IP-Slide',
                'INPIX PREMIUM IP_A',
                'INPIX PREMIUM_A',
                'INPIX RF_A',
                'IP - AI_A',
                'IP-GD',
                'Envato',
                'AI Generated',
                'IP-Gray',
                'IP - AI',
                'IP-Yellow',
                'IP-Wild',
                'Image Source RF',
                'Juice Images',
                'Food Collection',
                'Photononstop RF',
                'Robert Harding',
                'Image Source RM',
                'Universal Images Group',
                'Image Source Indian',
                'Majority World',
                'AgeFotostock (Pixtal)',
                'AgeFotostock (EASY)',
                'Alamy'
            ];
            allCollections = allCollections.filter((item: any) =>
                !hiddenCollectionNames.includes((item.name || '').trim())
            );

            // Filter collections based on platform (IP or IPB)
            this.collectionData = allCollections.filter(item =>
            item.platform && item.platform.includes(allowedPlatform)
            );

            // 🟢 Categorize collections
            if (this.category === 'editorial') {
            this.indianCollections = this.collectionData.filter(item => item.editorialIndianSearch);
            this.internationalCollections = this.collectionData.filter(item => item.editorialInternationalSearch);
            } else {
            this.indianCollections = this.collectionData.filter(item => item.creativeIndianSearch);
            this.internationalCollections = this.collectionData.filter(item => item.creativeInternationalSearch);
            }

            // 🟢 Handle video collections (if applicable)
            if (this.type === 'videos') {
            this.videoCollections = this.collectionData.filter(item =>
                (item.media_type === 'Video' || item.media_type === 'Both') &&
                item.id !== 130 && item.id !== 219
            );
            }
        });
        
    }

    containsAttrInUrl(type: string, value: string) {
        const currentQueries = this.params[type] ? this.params[type].split(',') : [];
        return currentQueries && currentQueries.includes(value);
    }

    getUrlForAttrs(type: string, value: string) {
        let currentQueries = this.params[type] ? this.params[type].split(',') : [];
        currentQueries = this.containsAttrInUrl(type, value) ? currentQueries.filter(item => item !== value) : [value];
        return currentQueries.join(',');
    }

    onAttrClick(attr: string, value: string) {
        let url = this.getUrlForAttrs(attr, value);
        this.router.navigate([], {queryParams: {[attr]: this.getUrlForAttrs(attr, value), page: 1}, queryParamsHandling: 'merge'});
    }

    filterDuration() {
        this.router.navigate([], {
            queryParams: {durationFrom: this.durationRange[0], durationTo: this.durationRange[1], page: 1},
            queryParamsHandling: 'merge'
        });
    }

    changeFilterDuration(value: any) {
        this.durationRange = [value[0], value[1]];
    }


    filterFps() {
        this.router.navigate([], {
            queryParams: {fpsFrom: this.fpsRange[0], fpsTo: this.fpsRange[1], page: 1},
            queryParamsHandling: 'merge'
        });
    }

    changeFilterFps(value: any) {
        this.fpsRange = [value[0], value[1]];
    }

    dropdownSettings: IMultiSelectSettings = {
        dynamicTitleMaxItems: 3,
        displayAllSelectedText: true,
        showCheckAll: true,
        showUncheckAll: true,
        enableSearch: false
    };

// Text configuration
    dropdownTexts: IMultiSelectTexts = {
        checkAll: 'Select all',
        uncheckAll: 'Unselect all',
        checked: 'item selected',
        checkedPlural: 'items selected',
        searchPlaceholder: 'Find',
        searchEmptyResult: 'Nothing found...',
        searchNoRenderText: 'Type in search box to see results...',
        defaultTitle: 'Indian Collection',
        allSelected: 'All Indian col. selected',
    };
    dropdownTextsInternational: IMultiSelectTexts = {
        checkAll: 'Select all',
        uncheckAll: 'Unselect all',
        checked: 'item selected',
        checkedPlural: 'items selected',
        searchPlaceholder: 'Find',
        searchEmptyResult: 'Nothing found...',
        searchNoRenderText: 'Type in search box to see results...',
        defaultTitle: 'International Collection',
        allSelected: 'All International col. selected',
    };
    dropdownTextsVideo: IMultiSelectTexts = {
        checkAll: 'Select all',
        uncheckAll: 'Unselect all',
        checked: 'item selected',
        checkedPlural: 'items selected',
        searchPlaceholder: 'Find',
        searchEmptyResult: 'Nothing found...',
        searchNoRenderText: 'Type in search box to see results...',
        defaultTitle: 'Video Collection',
        allSelected: 'All Video col. selected',
    };

    onIndianCollectionChange() {
        this.router.navigate([], {queryParams: {'indianCollection': this.indianSelect.toString(), page: 1}, queryParamsHandling: 'merge'});
    }

    onInternationalCollectionChange() {
        this.router.navigate([], {
            queryParams: {'internationalCollection': this.internationalSelect.toString(), page: 1},
            queryParamsHandling: 'merge'
        });
    }
    onVideoCollectionChange() {
        this.router.navigate([], {queryParams: {'videoCollection': this.videoSelect.toString(), page: 1}, queryParamsHandling: 'merge'});
    }

}
